import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m1.5 13.875 14 8a1 1 0 0 0 .993 0l14-8a1 1 0 0 0 0-1.737l-14-8a1 1 0 0 0-.993 0l-14 8a1 1 0 0 0 0 1.737M16 6.151l11.984 6.85L16 19.848 4.016 13zm14.868 11.35a1 1 0 0 1-.368 1.374l-14 8a1 1 0 0 1-.992 0l-14.008-8a1.006 1.006 0 0 1 1-1.744L16 24.85l13.5-7.718a1 1 0 0 1 1.368.37"
    />
  </svg>
);
const SvgIconStackSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconStackSimple);
export default Memo;
